export const COMPOSITIONS_PREFIX = "@COMPOSITIONS/"
export const FETCH_COMPOSITIONS = `${COMPOSITIONS_PREFIX}FETCH_COMPOSITIONS`
